import { IPalette, ISemanticColors } from '@fluentui/react';

import { IAppEffects } from '.';

export enum ThemeType {
  Light = 'Light',
  Dark = 'Dark',
}

export type FluentPalette = Pick<
  IPalette,
  | 'themePrimary'
  | 'themeLighterAlt'
  | 'themeLighter'
  | 'themeLight'
  | 'themeTertiary'
  | 'themeSecondary'
  | 'themeDarkAlt'
  | 'themeDark'
  | 'themeDarker'
  | 'neutralLighterAlt'
  | 'neutralLighter'
  | 'neutralLight'
  | 'neutralQuaternaryAlt'
  | 'neutralQuaternary'
  | 'neutralTertiaryAlt'
  | 'neutralTertiary'
  | 'neutralSecondary'
  | 'neutralPrimaryAlt'
  | 'neutralPrimary'
  | 'neutralDark'
  | 'black'
  | 'blackTranslucent40'
  | 'white'
  | 'whiteTranslucent40'
  | 'green'
>;

export type FluentSemanticColors = Pick<
  ISemanticColors,
  | 'bodyText'
  | 'bodySubtext'
  | 'errorText'
  | 'cardShadow'
  | 'cardShadowHovered'
  | 'buttonText'
  | 'buttonTextHovered'
  | 'buttonTextPressed'
  | 'buttonTextDisabled'
  | 'buttonBackground'
  | 'buttonBorder'
  | 'primaryButtonBackground'
  | 'primaryButtonBackgroundDisabled'
  | 'primaryButtonBackgroundHovered'
  | 'primaryButtonBackgroundPressed'
  | 'primaryButtonBorder'
  | 'primaryButtonText'
  | 'primaryButtonTextDisabled'
  | 'primaryButtonTextHovered'
  | 'primaryButtonTextPressed'
  | 'link'
  | 'linkHovered'
>;

export type FluentEffects = Pick<
  IAppEffects,
  'elevation2' | 'elevation4' | 'elevation8' | 'elevation16' | 'elevation28' | 'elevation64'
>;
